import { render } from "./MenuDetalle.vue?vue&type=template&id=fa008b2a&scoped=true"
import script from "./MenuDetalle.vue?vue&type=script&lang=js"
export * from "./MenuDetalle.vue?vue&type=script&lang=js"

import "./MenuDetalle.vue?vue&type=style&index=0&id=fa008b2a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa008b2a"]])

export default __exports__